import { Button, Card, Drawer, Flex, Image, Tag, Typography } from "antd";
import dayjs from "dayjs";
import {
  capitalizeTranslated,
  formatCompactAmount,
  formatDateTime,
  FormatDateTimeFun,
  LLFormat,
  LLFormatWithTime,
  SimpleDateFormat,
  SimpleMonthYearFormat,
  toCapitalize,
  utcDateTimeToLocalPA,
} from "../../../shared";
import { CloseOutlined } from "@ant-design/icons";
import { can } from "../../../Auth";

const { Title, Text } = Typography;
const MoreEventsDrawer = ({
  visible,
  onClose,
  selectedsessiondate,
  handleEventClick,
}) => {
  return (
    <Drawer
      title={
        <Flex justify="space-between" align="start" gap={10}>
          <Flex vertical>
            <Title level={4} className="m-0">
              {FormatDateTimeFun(selectedsessiondate?.sessionDate)}
            </Title>
          </Flex>
          <Button className="border-0 p-0 bg-transparent" onClick={onClose}>
            <CloseOutlined />
          </Button>
        </Flex>
      }
      placement="right"
      width={500}
      open={visible}
      onClose={onClose}
      closeIcon={false}
      footer={null}
      zIndex={999}
    >
      <Flex vertical gap={10}>
        {selectedsessiondate?.data?.map((event, index) => (
          <Card
            size="small"
            onClick={() => handleEventClick(event)}
            style={{
              borderLeft: `4px solid ${
                event?.status === "pending"
                  ? "#FFA500"
                  : event?.status === "completed"
                    ? "#52c41a"
                    : "#f5222d"
              }`,
            }}
          >
            <Flex vertical gap={4}>
              <Flex justify="space-between" gap={10}>
                <Text strong>{toCapitalize(event?.patientName)}</Text>
                <Text>
                  {can("Session Calendar Views", "view payment details") && (
                    <>
                      {formatCompactAmount(
                        event?.displayAmount?.toLocaleString(),
                      )}{" "}
                      (PKR)
                    </>
                  )}
                </Text>
              </Flex>
              <Flex gap={10}>
                <Text>
                  {utcDateTimeToLocalPA(event?.alldata?.sessionDateTime)}
                </Text>
                <Tag
                  color={
                    event?.status === "pending"
                      ? "#FFA500"
                      : event?.status === "completed"
                        ? "#52c41a"
                        : "#f5222d"
                  }
                  className="radius-12"
                >
                  {capitalizeTranslated(event?.status)}
                </Tag>
              </Flex>
              <Flex justify="end" gap={10} align="flex-start">
                <Flex justify="end">
                  <Tag className="m-0">
                    {toCapitalize(event?.alldata?.service?.name)}
                  </Tag>
                </Flex>
                {event?.alldata?.appointment?.client_info?.medical_info &&
                  Object.entries(
                    event?.alldata?.appointment?.client_info?.medical_info,
                  ).filter(
                    ([key, value]) => key.startsWith("is") && value === "1",
                  ).length > 0 && (
                    <Image
                      src={
                        event?.status === "cancel"
                          ? "/assets/images/issue-o.webp"
                          : "/assets/images/issue-r.webp"
                      }
                      width={5}
                      height={"auto"}
                      preview={false}
                    />
                  )}
              </Flex>
            </Flex>
          </Card>
        ))}
      </Flex>
    </Drawer>
  );
};

export { MoreEventsDrawer };
